import { Col, Row, Button } from 'reactstrap';
import { callApi } from '../../../utils';

import EditMerchantFaqModal from './EditMerchantFAQModal';
import CreateMerchantFaqModal from './CreateMerchantFAQModal';
import Loading from '../../Loading';
import React from 'react';
import { showError, showInfo } from '../../../actions/notificationActions';
import DataTable from '../../DataTable';

class MerchantFaq extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openEditFaqModal: false,
      openCreateFaqModal: false,
      editFaq: null,
      loading: true,
      rows: [],
      category: '',
    };
  }

  componentDidMount() {
    this.loadView();
    this.loadCategories();
  }

  startLoad = () => this.setState({ loading: true });
  stopLoad = () => this.setState({ loading: false });

  scrollToTop = () =>
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);

  loadView = (e) => {
    e && e.preventDefault();

    const { category } = this.state;

    this.startLoad();

    callApi(`/merchants/faq?category=${category}`)
      .then(({ data = [] }) => {
        this.setState({ rows: data });
        this.scrollToTop();
      })
      .catch((err) => {
        showError(err.message || 'Failed to load FAQs');
      })
      .finally(() => {
        this.stopLoad();
      });
  };

  openEditFaqModal = (row) => {
    this.setState({
      openEditFaqModal: true,
      editFaq: row,
    });
  };

  closeEditFaqModal = () => {
    this.setState({
      openEditFaqModal: false,
      editFaq: null,
    });
  };

  openCreateFaqModal = () => {
    this.setState({
      openCreateFaqModal: true,
    });
  };

  closeCreateFaqModal = () => {
    this.setState({
      openCreateFaqModal: false,
    });
  };

  deleteFaq = (id) => {
    if (window.confirm('Are you sure you want to delete this FAQ?')) {
      this.startLoad();
      callApi(`/merchants/faq/${id}`, {}, 'DELETE')
        .then(() => {
          showInfo('FAQ deleted successfully');
          this.loadView();
        })
        .catch((err) => {
          showError(err.message || 'Failed to delete FAQ');
          this.stopLoad();
        });
    }
  };

  changeCategory = (e) => {
    const category = e.target.value;
    this.setState({ category }, () => {
      this.loadView();
    });
  };

  render() {
    const {
      loading,
      rows,
      categories,
      openEditFaqModal,
      editFaq,
      openCreateFaqModal,
    } = this.state;

    return (
      <div>
        <Row style={{ marginBottom: '20px' }}>
          <Col sm="12" style={{ textAlign: 'right' }}>
            <Button
              color="success"
              onClick={this.openCreateFaqModal}
              style={{ padding: '8px 20px' }}
            >
              + Add FAQ
            </Button>
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            {loading ? (
              <Loading />
            ) : rows.length > 0 ? (
              <DataTable card={false} loading={loading} minWidth={700}>
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>Question</th>
                    <th>Category</th>
                    <th>Answers</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, i) => (
                    <tr key={row._id}>
                      <td>
                        <span>{i + 1}</span>
                      </td>
                      <td>
                        <span style={{ fontWeight: 'bold' }}>
                          {row.question}
                        </span>
                      </td>
                      <td>
                        <span
                          style={{
                            background: '#f0f0f0',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                          }}
                        >
                          {row.category || 'no category'}
                        </span>
                      </td>
                      <td>
                        <span style={{ fontSize: '12px', color: '#666' }}>
                          {row.answers.length || 0} answer(s)
                        </span>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: '10px' }}>
                          <div
                            style={{
                              marginBlock: '2px',
                              background: '#e95e38',
                              display: 'inline-block',
                              color: '#fff',
                              borderRadius: '30px',
                              padding: '8px 15px',
                              cursor: 'pointer',
                              fontSize: '12px',
                            }}
                            onClick={() => {
                              this.openEditFaqModal(row);
                            }}
                          >
                            Edit
                          </div>
                          <div
                            style={{
                              marginBlock: '2px',
                              background: '#dc3545',
                              display: 'inline-block',
                              color: '#fff',
                              borderRadius: '30px',
                              padding: '8px 15px',
                              cursor: 'pointer',
                              fontSize: '12px',
                            }}
                            onClick={() => {
                              this.deleteFaq(row._id);
                            }}
                          >
                            Delete
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </DataTable>
            ) : (
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <p>No FAQs found for this category</p>
              </div>
            )}
          </Col>
        </Row>

        {openEditFaqModal && editFaq ? (
          <EditMerchantFaqModal
            close={this.closeEditFaqModal}
            open={openEditFaqModal}
            faq={editFaq}
            refreshFaq={this.loadView}
            categories={categories}
          />
        ) : null}

        {openCreateFaqModal ? (
          <CreateMerchantFaqModal
            close={this.closeCreateFaqModal}
            open={openCreateFaqModal}
            refreshFaq={this.loadView}
            categories={categories}
          />
        ) : null}
      </div>
    );
  }
}

export default MerchantFaq;
